// Source: https://usehooks-ts.com/react-hook/use-window-size.
import { useState } from 'react';
import useDebounceCallback from './use-debounce-callback.js';
import useEventListener from './use-event-listener.js';
import useIsomorphicLayoutEffect from './use-isomorphic-layout-effect.js';
const IS_SERVER = typeof window === 'undefined';
/**
 * Custom hook that tracks the size of the window.
 */
function useWindowSize(options = {}) {
    let { initializeWithValue = true } = options;
    if (IS_SERVER) {
        initializeWithValue = false;
    }
    const [windowSize, setWindowSize] = useState(() => {
        if (initializeWithValue) {
            return {
                width: window.innerWidth,
                height: window.innerHeight,
            };
        }
        return {
            width: undefined,
            height: undefined,
        };
    });
    const debouncedSetWindowSize = useDebounceCallback(setWindowSize, options.debounceDelay);
    function handleSize() {
        const setSize = options.debounceDelay
            ? debouncedSetWindowSize
            : setWindowSize;
        setSize({
            width: window.innerWidth,
            height: window.innerHeight,
        });
    }
    useEventListener('resize', handleSize);
    // Set size at the first client-side load.
    useIsomorphicLayoutEffect(() => {
        handleSize();
    }, []);
    return windowSize;
}
export default useWindowSize;
